import PropTypes from "prop-types";

const FacebookIcon = ({ color = "white", bgColor = "#7B9E7E" }) => {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.568359"
        y="0.258301"
        width="29.9111"
        height="29.9111"
        rx="4.78577"
        fill={bgColor}
      />
      <path
        d="M21.4009 13.9644L21.1211 16.205C21.0738 16.5793 20.7559 16.8608 20.3789 16.8608H16.7398V26.2288C16.356 26.2634 15.9672 26.2811 15.5741 26.2811C14.695 26.2811 13.8369 26.1934 13.0077 26.0265V16.8608H10.2088C9.95183 16.8608 9.74219 16.6509 9.74219 16.3938V13.5901C9.74219 13.333 9.95183 13.1231 10.2088 13.1231H13.0077V8.91834C13.0077 6.338 15.0965 4.24658 17.6739 4.24658H20.9394C21.1964 4.24658 21.406 4.45648 21.406 4.71359V7.51732C21.406 7.77443 21.1964 7.98433 20.9394 7.98433H18.6063C17.5758 7.98433 16.7406 8.82056 16.7406 9.8532V13.1239H20.6596C21.1093 13.1239 21.4567 13.5184 21.4018 13.9652L21.4009 13.9644Z"
        fill={color}
      />
    </svg>
  );
};

const { string } = PropTypes;

FacebookIcon.propTypes = {
  color: string,
  bgColor: string
};

export default FacebookIcon;
